export enum PAYMENTMETHOD {
    KC,
    AC,
    CO
}

export enum CARDTYPE {
    EXISTINGCARD,
    NEWCARD
}

export enum UPLOADFILETYPE {
    CSV,
    TXT
}

export enum AVAILABILITYTYPE {
    da,
    ka
}

export enum CARTDOWNLOADFIELD {
    dealerAvailability,
    komastuAvailability,
    branchAvailability,
    manufacturer,
    machine,
    itemTotal,
    unitPrice
}

export enum MININGPRODUCTTYPE {
    ELECTRIC_SHOVEL,
    DIPPER,
    LOADER,
    DRILL
}